<template>
	<div v-if="wishlistRecipes && wishlistRecipes.length > 0" :class=" {'checkout-layout': $route.name === 'flow-subscribed'}">
		<transition name="modal-on" v-if="$mq.isDesktop()">
			<div
				v-if="showShare"
				class="widget shadow-box"
				:style="[$_appViewPosition_positionTop, $_appViewPosition_positionBottom]"
			>
				<div class="modal-close-x flex-center" @click="close()">
					<i class="fas fa-times" />
				</div>

				<h3 v-if="wishlistMode === 'recieved_recipes'">
					Ecco dei suggerimenti per te:
				</h3>
				<h3 v-if="wishlistMode === 'creating_wishlist'">
					{{
						wishlist.length > 1
							? `Le tue ricette preferite:`
							: `La tua ricetta preferita:`
					}}
				</h3>

				<div v-for="recipe in wishlistRecipes" class="bill-item">
					<div class="recipe-image">
						<img :src="recipe.images.big">
					</div>
					<div
						class="recipe-name"
						v-html="recipe.name"
					/>
				</div>

				<div v-if="$route.name !== 'flow-subscribed' && wishlistMode === 'creating_wishlist'">
					<div>
						<br>Condividi:
					</div>
					<social-share
						v-if="$route.name !== 'flow-subscribed'"
						:whatsapp="`Ciao! Ecco le mie ricette preferite del menù Quomi di questa settimana: ${link}`"
						:mail="{ subject: 'Cosa ne pensi della mia scelta?', body: `Ciao! Ecco le mie ricette preferite del menù Quomi di questa settimana: ${link}` }"
						:copyString="link"
					/>
				</div>
			</div>
		</transition>
		<transition name="slide-fade" v-if="!$mq.isDesktop()">
			<div
				v-if="showShare"
				class="overlay"
				:style="[$_appViewPosition_positionTop, $_appViewPosition_positionBottom]"
			>
				<h4
					@click="close()"
					class="top-bar"
				>
					<i class="fas fa-angle-left" /> Ricette
				</h4>
				<div
					class="view"		
				>
					<h3 v-if="wishlistMode === 'recieved_recipes'">Ecco dei suggerimenti per te:</h3>
					<h3 v-if="wishlistMode === 'creating_wishlist'">
						{{
							wishlist.length > 1
								? `Le tue ricette preferite:`
								: `La tua ricetta preferita:`
						}}
					</h3>
					<div v-for="recipe in wishlistRecipes" class="bill-item">
						<div class="recipe-image full">
							<img :src="recipe.images.big">
						</div>
						<div
							class="recipe-name"
							v-html="recipe.name"
						/>
					</div>

					<br>
					<div class="" v-if="$route.name !== 'flow-subscribed'">
						<social-share
							:whatsapp="`Ciao! Ecco le mie ricette preferite del menù Quomi di questa settimana: ${link}`"
							:mail="{ subject: 'Cosa ne pensi della mia scelta?', body: `Ciao! Ecco le mie ricette preferite del menù Quomi di questa settimana: ${link}` }"
							:copyString="link"
						/>
					</div>
				</div>
			</div>
		</transition>

		<transition name="modal-on">
			<div
				:style="[$_appViewPosition_transformYfromBottom]"
				class="widget heart flex-center shadow-box"
				@click="showShare = !showShare"
				v-if="wishlist && wishlist.length > 0"
			>
				<i class="fas fa-heart"></i>
			</div>

		</transition>
	</div>
</template>

<script type="text/javascript">
	import SocialShare from './SocialShare'

	export default {
		data () {
			return {
				showShare: false
			}
		},

		props: {
			wishlist: {
				type: Array,
				default () {
					return null
				}
			},
			wishlistRecipes: {
				type: Array,
				default () {
					return null
				}
			},
			wishlistMode: {
				type: String,
				default: null
			},

			link: {
				type: String,
				default: null
			}
		},

		components: {
			SocialShare
		},

		methods: {
			close () {
				this.showShare = false
			}
		}
	}
</script>

<style type="text/css" scoped>

.overlay {
	position: fixed;
	top: 0;
	width: 100%;
	left: 0;
	height: 100vh;
	z-index: 9999;
	background: white;
}
.view {
	height: 100vh;
	overflow-y: auto;
	width: 100%;
	padding: 20px;
}

.top-bar {
	cursor: pointer;
	border-bottom: 1px solid #ededed;
    padding: 21px 8px 13px 8px;
}

h4 {
    font-size: 18px;
    text-align: left;
}
	
.bottom-bar {
	position: fixed;
	bottom: 0px;
	width: 100%;
	left: 0px;
	height: 20px;
	z-index: 2;
	border-radius: 0;
	background: white;
	padding: 20px;
	cursor: pointer;
}

.image {
	max-width: 200px;
}

.recipe-image {
	min-width: 50px;
	min-height: 33px;
	max-width: 50px;
	max-height: 33px;
	overflow: hidden;
	vertical-align: middle;
	margin-right: 10px;
	border-radius: 4px;
}

.recipe-image.full {
	min-width: 100px;
	min-height: 66px;
	max-width: 100px;
	max-height: 66px;
}

.recipe-name {
	display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 40px;
    position: relative;
	line-height: 1.1;
	overflow: hidden;
}

.bill-item {
	margin: 10px 0;
	display: flex;
    align-items: center;
    line-height: 1.2;
}

.icons-panel {
	justify-content: flex-start;
	margin-top: 10px;
}
	
.widget {
	position: fixed;
	bottom: 20px;
	right: 20px;
	z-index: 10;
	background: white;
	padding: 30px;
	height: auto;
	max-width: 400px;
}

.checkout-layout .widget {
	bottom: 90px;
}

.checkout-layout .bottom-bar {
	bottom: 60px;
}

.widget.heart {
	border-radius: 50%;
	width: 70px;
	height: 70px;
	cursor: pointer;
	z-index: 9;
}

.fa-heart {
	transform: scale(1.8);
	color: var(--quomi-red);
}

.modal-close-x {
	z-index: 1;
	position: absolute;
	top: 0px;
	right: 0px;
	width: 32px;
	height: 32px;
	text-align: center;
	color: grey;
	border-radius: 50%;
	font-size: 18px;
	cursor: pointer;
	line-height: 1;
}

@media (max-width: 1024px) {
	.checkout-layout .widget {
		bottom: 70px;
	}
}
</style>